import iconError from '../../../assets/images/icon-error.png';
import primaryButtonStyle from '../../UI/primaryButtonStyle';

export const useStyles = (theme) => ({
	fsMd: {
		fontSize: 16,
	},
	btnLink: {
		textDecoration: 'underline',
		cursor: 'pointer',
	},
	paymentInfoContainer: {
		margin: 0,
		borderRadius: 8,
		maxWidth: '100%',
		fontSize: 14,
		lineHeight: '22px',
		color: '#93999C',
		fontWeight: 600,
		fontFamily: 'Spartan, sans-serif',
	},

	paymentNotEligible: {
		color: '#A01C47',
		fontSize: 14,
		fontWeight: 600,
		'& a': {
			textDecoration: 'underline',
			cursor: 'pointer',
		},
	},
	paymentInfoSaving: {
		fontSize: 16,
		fontWeight: 700,
		color: '#1C1E22',
		background: '#84E8C5',
		width: '100%',
		padding: 10,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
	},
	lineThrough: {
		textDecoration: 'line-through',
	},
	discount: {
		fontSize: 16,
		lineHeight: '26px',
		color: '#283339',
		fontWeight: 700,
	},
	total: {
		color: '#283339',
		fontSize: 24,
		fontWeight: 700,
		lineHeight: '36px',
		marginBottom: 20,
	},
	textGreen: {
		color: '#1C9A6E',
	},
	separator: {
		height: 0,
		borderBottom: '1px solid #E9EAEB',
	},
	billingInfo: {
		paddingLeft: 30,
		fontSize: 12,
		lineHeight: '13px',
		color: '#93999C',
		fontWeight: 500,
		marginTop: -4,
	},
	errorIcon: {
		position: 'relative',
		top: '5px',
		paddingLeft: 20,
		fontSize: 11,
		fontWeight: 600,
		color: '#E52866',
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: '-2px',
			left: 3,
			width: 15,
			height: 13,
			backgroundImage: `url(${iconError})`,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},

	},
	checkbox: {
		marginTop: '-9px',
	},
	checkboxError: {
		color: '#f44336',
	},
	errorText: {
		position: 'absolute',
		top: 50,
		left: 0,
		width: 'auto',
		color: '#f44336',
		fontSize: '0.75rem',
		lineHeight: 1,
	},
	termsContainer: {
		position: 'relative',
		textAlign: 'center',
	},
	termsCheckbox: {
		alignItems: 'flex-start',
	},
	terms: {
		fontSize: 12,
		lineHeight: '19px',
		display: 'inline-block',
		color: '#93999C',
		fontWeight: 600,
		'& a': {
			textDecoration: 'underline',
			color: '#93999C'
		}
	},
	submit: {
		...primaryButtonStyle(),
		margin: theme.spacing(1, 0, 1),
		padding: 10,
		fontSize: 16,
		lineHeight: '40px',
		maxWidth: 240,
		minWidth: 240,
	},
	info: {
		fontSize: 12,
		fontWeight: 500,
		lineHeight: '19px',
		color: '#283339',
	},
	moneyBack: {
		padding:  24,
		background:  '#FFEFDB',
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
	moneyBackTitle: {
		color: '#283339',
		fontWeight: 700,
		fontSize: 16,
		lineHeight: '26px',
		marginBottom: 8,
	},
	moneyBackContent:  {
		color: '#525B60',
		fontWeight: 600,
		fontSize: 12,
		lineHeight: '19px',
	},
	amexWarning: {
		'& $errorIcon': {
			fontSize: 14,
			fontWeight: 700,
			display: 'block',
			'&::before': {
				top: 1,
			},
		}
	},
	paymentInfoSentry: {
		display: 'flex',
		alignItems: 'center',
		color: '#283339',
		background: '#F9F9F9',
		borderRadius: 12,
		padding: '14px 16px',
		fontSize: 14,
		lineHeight: '22px',
		fontWeight: 700,
		marginLeft: '-16px',
		marginRight: '-16px',
	},
	paymentInfoAddSentry: {
		padding: '8px 20px 5px',
		cursor: 'pointer',
		border: 'solid 2px #FF8F00',
		color: '#FF8F00',
		borderRadius: '10px',
		fontSize: 15,
		display: 'inline-block',
		transition: 'all 0.2s ease-in-out',
		'&:hover': {
			color: '#fff',
			border: 'solid 2px #FF8F00',
			backgroundColor: '#FF8F00',
		},
	},
	'@media (max-width: 500px)': {
		paymentInfoSaving: {
			alignSelf: 'flex-end',
			marginTop: 5,
		},
	},
	'@media (max-width: 460px)': {
		paymentTotal: {
			fontSize: 18,
		},
	},
});